import * as leadformConstants from '../constants';

export default function getFields(element){
  return [...element.querySelectorAll(leadformConstants.leadformTagNames.fields.join(','))];
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/element/get_fields.js